import { Box, BoxProps, Text } from '@chakra-ui/react';
import { Row } from '@tanstack/react-table';
import { HighlightSearchTerm } from '~/components/HighlightSearchTerm';
import Tooltip from '~/components/Tooltip';
import { useHover } from '~/screens/MyAgency/hooks/useHover';
import { ICreator } from '~/types';
import { convertPxToRems } from '~/utils-ts';

import { EmptyCell } from './Columns';
import { myAgencyListRowTrackId } from './constants';
import { cellContainer } from './styles';

interface Props extends BoxProps {
  row: Row<ICreator>;
}

export const BioCell: React.FC<Props> = ({ row }) => {
  const [hoverElemRef] = useHover<HTMLDivElement>();
  const { bioAgency } = row.original;

  return (
    <Box ref={hoverElemRef} {...cellContainer}>
      {bioAgency ? (
        <Tooltip
          label={bioAgency}
          marginLeft="auto"
          isTouchFriendly={false}
          bg="black"
          color="white"
          fontSize="md"
          placement="bottom"
        >
          <Text
            color="primary.400"
            display="inline"
            fontSize="sm"
            fontWeight="400"
            overflow="hidden"
            textOverflow="ellipsis"
            width={convertPxToRems(300)}
            lineHeight={convertPxToRems(14)}
            _hover={{
              cursor: 'pointer',
            }}
            noOfLines={2}
            track-id={myAgencyListRowTrackId.creatorBio}
          >
            <HighlightSearchTerm>{bioAgency}</HighlightSearchTerm>
          </Text>
        </Tooltip>
      ) : (
        <EmptyCell content="-" />
      )}
    </Box>
  );
};
